<template>
    <q-card inline style="width: 100%; margin: 10px;">
        <q-card-title>
            Change Status
        </q-card-title>
        <q-card-main>
            <v-select :options="stockOrderStatus" :label="$t('stock order status')" :form="form"
                v-model="stockOrderStatusValue" :clearable="false">
            </v-select>
            <v-datetime path="pick_date" :label="$T('pick date')" :form="form" v-model="pickDateValue" type="datetime">
            </v-datetime>
        </q-card-main>
        <q-card-separator />
        <q-card-main>
            <div class="overflow-hidden overflow-x-auto relative">
                <table style="width: 100%">
                    <thead>
                        <tr>
                            <th colspan="5" class="w-8" style="text-align: left;">Lending Kits</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in listStockOrderItems">
                            <td>#{{ index + 1 }}</td>
                            <td>
                                <v-input label="productCode" :form="form" v-model="item.productCode">
                                </v-input>
                            </td>
                            <td>
                                <v-input label="productDescription" :form="form" v-model="item.productDescription">
                                </v-input>
                            </td>
                            <td>
                                <v-input type="number" label="quantity" :form="form" v-model="item.quantity">
                                </v-input>
                            </td>
                            <td>
                                <v-input label="Codentify" :form="form" v-model="item.codentify">
                                </v-input>
                            </td>
                            <td>
                                <v-button class="no-shadow capitalize" color="negative" no-caps icon="delete"
                                    dusk="confirm-delete-button" @click="deleteLendingKit(index)">
                                </v-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <v-button :label="$t('add Lending Kit')" icon="save" color="highlight"
                class="no-shadow uppercase q-btn-iqos" size="md" style="margin-top: 10px;" @click="addLendingKit" />
        </q-card-main>
        <q-card-separator />
        <q-card-main>
            <v-button :label="$t('save')" outline size="md" @click="handleChangeStatus" />
        </q-card-main>
    </q-card>
</template>

<script>
import mixins from './mixins'
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import {
    QInputFrame
} from 'quasar-framework'

export default {
    name: 'VStockOrderChangeStatus',
    components: { QInputFrame },
    mixins,

    props: {
        value: {
            type: String,
        },
        color: {
            type: String,
        }
    },

    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),
        isInProduction() {
            return this.stockOrderStatusValue == 'In Production'
        },
        stockOrderStatus() {
            let status = [
                {
                    label: 'Pending',
                    value: 'Pending'
                },
                {
                    label: 'In Production',
                    value: 'In Production'
                },
                {
                    label: 'In Transit',
                    value: 'In Transit'
                },
                {
                    label: 'Executed',
                    value: 'Executed'
                },
                {
                    label: 'Rejected',
                    value: 'Rejected'
                }
            ];

            if (this.form['stock_operation.description'] == 'Entrega') {
                status.push({
                    label: 'Completed',
                    value: 'Completed'
                })
            }

            return status
        }
    },

    data() {
        return {
            stockOrderStatusValue: this.form['stock_order_status.description'],
            pickDateValue: null,
            listStockOrderItems: []
        }
    },

    methods: {
        addLendingKit() {
            this.listStockOrderItems.push({
                productCode: '',
                productDescription: '',
                quantity: 1,
                codentify: '',
            })
        },
        deleteLendingKit(index) {
            if (index > -1) {
                this.listStockOrderItems.splice(index, 1);
            }
        },
        handleChangeStatus() {
            const that = this;

            if (
                that.listStockOrderItems.length > 0 && (that.listStockOrderItems.filter((item) => !item.productCode || !item.productDescription || !item.quantity || !item.codentify).length)
            ) {
                return that.$q.dialog({
                    title: 'Atenção',
                    message: 'Por favor, preencha todos os campos do lending kit',
                    color: 'negative',
                    ok: {
                        label: that.$t('ok'),
                    },
                })
            }

            let data = {
                _method: 'PUT',
                orderType: "pos",
                orderStatus: that.stockOrderStatusValue,
                data: that.listStockOrderItems
            }

            if (that.pickDateValue) {
                data.pickingDate = moment(that.pickDateValue, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm:00')
            }

            axios.post(`/api/stock-order-change-status/${that.form.id}`, data, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    localStorage.setItem('openModal', that.form.id)
                    let url = new URL(window.location.href);
                    window.location.href = url.href;
                })
                .catch(error => {
                    let errorMessage = '';

                    if (typeof error.response.data.error !== 'undefined') {
                        errorMessage += `${error.response.data.error} `;
                    }

                    if (typeof error.response.data.message !== 'undefined') {
                        errorMessage += `${error.response.data.message} `;
                    }

                    if (typeof error.response.data.data == 'object') {
                        const errorDetails = Object.values(error.response.data.data)
                            .map(item => item)
                            .join(', ');
                        errorMessage += errorDetails;
                    }

                    if (errorMessage) {
                        that.$q.notify({
                            color: 'negative',
                            icon: 'thumb_down',
                            message: errorMessage.trim()
                        });
                    }
                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VStockOrderChangeStatus.vue